import React, { useEffect, useMemo, useState } from 'react';
import { CustomSelect } from 'web-library';


import { makeStyles } from 'tss-react/mui';
import FormControl from 'web-library/stories/atom/FormControl/FormControl';
import { MenuItems } from './model';
import { CodeValueResponse } from '../../api';
import { useGetExamLevelOptions } from '../../api/candidate/resit/@opadmin/queries-services/queries';
import { SelectChangeEvent } from '@mui/material';

const useStyles = makeStyles()((theme) =>
({
  fromControlContainer: {
    display: 'flex',
    marginBottom: theme.spacing(3),
    width:'100%'
  },
}));

export interface ExamLevelMultiSelectProps {
  /** to handle select on change event
   * */
  onChange?: (event: CodeValueResponse[]) => void;

  /** to define select control selected value
   * */
  value: string[];

  /** to define option label
   * */
  label: string;

  /** to define function for access check
   * */
  accessFunction?: string;
}

/** reusable select component for exam levels option
 * */
const ExamLevelMultiSelect: React.FC<ExamLevelMultiSelectProps> = (
  props: ExamLevelMultiSelectProps
) => {
  const {
    value = [],
    label,
    onChange = (_event: CodeValueResponse[]) => {
      // do nothing
    },
    accessFunction,
  } = props;
  const [examLevels, setExamLevels] = useState<CodeValueResponse[]>([]);

  const { classes } = useStyles();

  const { refetch } = useGetExamLevelOptions(
    { functionName: accessFunction },
    {
      enabled: true,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      onSuccess: (responseData) => {
        if (responseData && responseData.length > 0) {
          setExamLevels(responseData);
        }
      },
    }
  );

  /** reform data into CustomSelect MenuItems
   * */
  const dropDownData = useMemo<MenuItems[]>(() => {
    if (!examLevels) {
      return [];
    }
    return examLevels.map((option) => ({
      children: option.codeValueDescription,
      value: option.codeValue,
      key: `k-${option.codeValue}`,
    }));
  }, [examLevels]);

  /** handle select on Change
   * */
  const onSelectOptionChange = (selectedValue: any[] | unknown) => {
    if (Array.isArray(selectedValue) && examLevels && examLevels.length > 0) {
      onChange(examLevels.filter((exam) => selectedValue.includes(exam.codeValue)));
    }
  };

  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <FormControl className={classes.fromControlContainer}>
      <CustomSelect
        displayEmpty
        label={label}
        labelId="inputSelectLabel-schoolCodeOptions"
        id="inputSelect-schoolCodeOptions"
        variant="filled"
        multiple
        onChange={(e: SelectChangeEvent<unknown>) => {
          onSelectOptionChange(e.target.value);
          window.dispatchEvent(new CustomEvent('resize'));
        }}
        menuItems={dropDownData}
        value={value}
        renderValue={(selected: unknown | string[]) =>
          Array.isArray(selected) && selected.length > 0
            ? examLevels
              .filter((examLevel) => selected.includes(examLevel.codeValue))
              .map((s) => s.codeValueDescription)
              .join(', ')
            : 'Select Exam Level'
        }
      />
    </FormControl>
  );
};
export default ExamLevelMultiSelect;
